export const SELLER_ID_WIDTH = '4em';
export const AMOUNT_BEFORE_ID_WIDTH = '7em';